import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth-guard.guard';
import { QuestionSetContainerComponent } from './components/application-form/question-set-container/question-set-container.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { SearchApplicationFormsComponent } from './components/search-application-forms/search-view/search-application-forms.component';
import { LogoutComponent } from './components/un-authorized-pages/logout/logout.component';

const routes: Routes = [
  {
    path: 'application_form',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: QuestionSetContainerComponent },
      { path: 'businessinfo', component: QuestionSetContainerComponent },
      { path: 'generalinfo', component: QuestionSetContainerComponent },
      { path: 'addlquestions', component: QuestionSetContainerComponent },
      { path: 'quote', component: QuestionSetContainerComponent }
    ]
  },
  { path: 'quoteredirect', component: QuestionSetContainerComponent, canActivate: [AuthGuard] },
  { path: 'search_forms', component: SearchApplicationFormsComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: HomePageComponent, canActivate: [AuthGuard] },
  { path: 'logout', component: LogoutComponent },
  { path: 'auth/callback', component: HomePageComponent, canActivate: [AuthGuard] },
  { path: '**', component: HomePageComponent, canActivate: [AuthGuard] },
  {
    path: 'auth/callback',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
